<template>
  <div class="page" :class="{ inApp: $root.isApp || this.$root.miniprogram }">
    <common-title titleName="集训营" :zIndex="1000"></common-title>
    <div class="form_list" v-if="formList.length > 0">
      <div class="form_item" v-for="item in formList" :key="item.id">
        <div class="form_title">{{item.title}}</div>
        <div class="form_btn" @click="onGoIform(item.formId)">去填写</div>
      </div>
    </div>
    <div class="quexing" v-else>
      <img
        class="img"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/class_form_empty.png"
        alt
      />
      <div class="text">当前没有需要填写的问卷</div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import { setBaseUrl } from '@/utils/tools';
// eslint-disable-next-line import/no-cycle
import { reqQuestionnaireList } from '@/api/trainEntrance/index';

export default {
  data() {
    return {
      formList: [
        // {
        //   title: '1',
        // },
        // {
        //   title: '1',
        // },
        // {
        //   title: '1',
        // },
      ],
    };
  },
  methods: {
    onGoIform(id) {
      const { classId } = this.$route.query;

      if (this.$root.isApp) {
        this.$sendToApp(
          'openNewWebView',
          { url: `${setBaseUrl('')}/iform/index/${id}?classId=${classId}` },
          false,
        );
      } else {
        window.location.href = `${window.location.origin}/iform/index/${id}?classId=${classId}`;
      }
      //   this.$router.push({
      //     path: '/trainEntrance/questionnaire',
      //     query: {},
      //   });
    },
  },
  created() {},
  mounted() {
    document.title = '问卷调研';
    const { classId } = this.$route.query;
    reqQuestionnaireList(classId).then(res => {
      console.log(res, '问卷');
      this.formList = res.data;
    });
    document.addEventListener(
      'visibilitychange',
      () => {
        console.log('visibilitychange');
        document.title = '问卷调研';
        reqQuestionnaireList(classId).then(res => {
          console.log(res, '问卷');
          this.formList = res.data;
        });
      },
      false,
    );
  },
};
</script>
<style lang="scss" scoped>
.inApp {
  padding-top: 20px !important;
}
.page {
  width: 100%;
  height: 100%;
  padding-top: 101px;
  padding-bottom: 210px;
  background: #f9f9f9;

  .quexing {
    padding-top: 312px;

    .img {
      display: block;
      width: 326px;
      height: 254px;
      margin: 0 auto 0;
    }
    .text {
      width: 100%;
      height: 40px;
      color: #787878;
      font-weight: 400;
      font-size: 29px;
      font-family: PingFangSC, PingFang SC, sans-serif;
      line-height: 40px;
      text-align: center;
    }
  }

  .form_list {
    width: 100%;
    height: 100%;
    padding: 29px 36px;
    background: #f7f8fc;

    .form_item {
      width: 678px;
      height: 109px;
      margin-bottom: 22px;
      background: #fff;
      border-radius: 14px;

      .form_title {
        float: left;
        width: 466px;
        height: 36px;
        margin-top: 36px;
        margin-left: 29px;
        overflow: hidden;
        color: #333;
        font-weight: 500;
        font-size: 18px;
        font-size: 25px;
        font-family: PingFangSC, PingFang SC, sans-serif;
        line-height: 36px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .form_btn {
        float: right;
        width: 125px;
        height: 42px;
        margin-top: 33px;
        margin-right: 29px;
        color: #fff;
        font-weight: 400;
        font-size: 22px;
        line-height: 42px;
        text-align: center;
        background: #ff7f41;
        border-radius: 21px;
      }
    }
  }
}
</style>
